import { useCountriesDictionary } from '@/shared/api';
import { buildLanguageSelectOptions } from '@/shared/lib/localization';

export const useLanguageOptions = () => {
  const { countriesData } = useCountriesDictionary();

  const languageOptions = buildLanguageSelectOptions(
    countriesData?.value ?? []
  );

  return {
    languageOptions,
  };
};
